var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonConformite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 100",
    style: {
      enableBackground: "new 0 0 125 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE7203;}\r\n\t.st1{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.3,76L86.6,65.3l0.2-0.2l10.5-10.5c0.4-0.4,0.4-1.3,0-1.8c-0.4-0.4-1.3-0.4-1.8,0L84.9,63.5l-0.2-0.2 L74.2,52.8c-0.4-0.4-1.3-0.4-1.8,0c-0.2,0.2-0.4,0.7-0.4,0.9c0,0.4,0.2,0.7,0.4,0.9l10.7,10.7l-0.2,0.2L72.4,76 c-0.4,0.4-0.4,1.3,0,1.8c0.4,0.4,1.3,0.4,1.8,0l10.7-10.7l0.2,0.2l10.5,10.5c0.4,0.4,1.3,0.4,1.8,0C97.8,77.3,97.8,76.6,97.3,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86,13.5c0-0.7-0.7-1.3-1.3-1.3h-56c-0.7,0-1.3,0.7-1.3,1.3v72.9c0,0.7,0.7,1.3,1.3,1.3h56 c0.7,0,1.3-0.7,1.3-1.3v-6c0-0.7-0.7-1.3-1.3-1.3c-0.7,0-1.3,0.7-1.3,1.3v4.7H29.8V14.9h53.5v34.3c0,0.7,0.7,1.3,1.3,1.3 c0.7,0,1.3-0.7,1.3-1.3V13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.2,29.6H37.1c-0.7,0-1.3,0.7-1.3,1.3c0,0.7,0.7,1.3,1.3,1.3h30.1c0.7,0,1.3-0.7,1.3-1.3 C68.6,30.3,67.9,29.6,67.2,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.8,56.1H36.9c-0.7,0-1.3,0.7-1.3,1.3s0.7,1.3,1.3,1.3h12.9c0.7,0,1.3-0.7,1.3-1.3S50.7,56.1,49.8,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.5,43H37.4c-0.7,0-1.3,0.7-1.3,1.3s0.7,1.3,1.3,1.3h30.1c0.7,0,1.3-0.7,1.3-1.3S68.1,43,67.5,43z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonConformite);
export default __webpack_public_path__ + "static/media/non-conformite.bd6425a7e3b4c2b5a9aa6ab3c5f0b185.svg";
export { ForwardRef as ReactComponent };